import { Stack } from "@mui/material";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { DashboardSectionHeader } from "web_myplann/Dashboard/Components/DashboardSectionHeader";
import { DashboardSkeleton } from "web_myplann/Dashboard/Components/DashboardSkeleton";
import { FaultyFinancialBalance } from "web_myplann/Dashboard/Components/FaultyFinancialBalance";
import { FinancialBalanceEmptyCard } from "web_myplann/Dashboard/Components/FinancialBalanceEmptyCard";
import { FinancialBalanceSummaryCard } from "web_myplann/Dashboard/Components/FinancialBalanceSummaryCard";
import { useFinancialBalance } from "web_myplann/Dashboard/Hooks/useFinancialBalance";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

const R = Resources.Dashboard.FinancialBalance;

export const FinancialBalanceV2: FC = () => {
	const { t } = useResource();
	const navigate = useNavigate();

	const { isLoading, hasNoData, hasNoBalance, incomeSum, expenseSum, balance } =
		useFinancialBalance();

	if (hasNoData && !isLoading) {
		return <FaultyFinancialBalance />;
	}

	if (isLoading) {
		return (
			<Stack px={1.6}>
				<DashboardSkeleton height={200} />
			</Stack>
		);
	}

	const goToDetail = () =>
		navigate(Routing.Finances.Intro.path(), {
			state: { from: "dashboard", wizardDepth: 1 },
		});

	const goToStart = () =>
		navigate(Routing.Finances.Income.path(), {
			state: { from: "dashboard", wizardDepth: 1 },
		});

	return (
		<Stack>
			<DashboardSectionHeader
				title={t(R.title)}
				actionLabel={hasNoBalance ? undefined : t(R.detail)}
				onAction={hasNoBalance ? undefined : goToDetail}
			/>
			<Stack px={1.6} pb={1.6}>
				{hasNoBalance ? (
					<FinancialBalanceEmptyCard onClick={goToStart} />
				) : (
					<FinancialBalanceSummaryCard
						income={incomeSum}
						expense={expenseSum}
						balance={balance}
						currencySign={t(Resources.Common.CurrencySign)}
						onClick={goToDetail}
					/>
				)}
			</Stack>
		</Stack>
	);
};
